import {createErrorHandlingThunk} from "../../../auth/redux/utils";
import {CreateWorkerData, FeWorker, UpdateWorkerInput, UpdateWorkerResult, UpdateWorkerStatusResult} from "./types";
import {WorkersService} from "./workers.service";

const workerService = new WorkersService();

export const createWorkerThunk = createErrorHandlingThunk<FeWorker, CreateWorkerData>(
    'workers/create',
    (dto) => workerService.createWorker(dto)
);

export const updateWorkerThunk = createErrorHandlingThunk<UpdateWorkerResult, { id: string, dto: UpdateWorkerInput }>(
    'workers/update',
    (args) => workerService.updateWorker(args.id, args.dto)
);

export const updateWorkerStatusThunk = createErrorHandlingThunk<UpdateWorkerStatusResult, { id: string, active: boolean }>(
    'workers/status/update',
    (args) => workerService.updateWorkerStatus(args.id, args.active)
);

export const addWorkerServiceThunk =  createErrorHandlingThunk<{ workerId: string, serviceId: string }, { workerId: string, serviceId: string }>(
    'workers/service/add',
    (args) => workerService.addWorkerService(args.workerId, args.serviceId)
);

export const removeWorkerServiceThunk =  createErrorHandlingThunk<{ workerId: string, serviceId: string }, { workerId: string, serviceId: string }>(
    'workers/service/remove',
    (args) => workerService.removeWorkerService(args.workerId, args.serviceId)
);

export const listWorkersThunk = createErrorHandlingThunk(
    'workers/list',
    () => {
        console.log("thunk called")
        return workerService.listWorkers()
    }
);

export const getWorkerThunk = createErrorHandlingThunk<FeWorker, {id: string}>(
    'workers/get',
    (args) => workerService.getWorker(args.id)
);
